import type { CanvasAgentNode } from '../canvas-view/canvas-view-model';
import { orderForOverview } from '../design-agents/design-agents-model';
import type { ExpectedAgent } from './validate-runs';

/**
 * The agents a designer can say should handle a scenario or a Test chat:
 * the solution's Build agent groups, in the Design page's order (Supervisor,
 * Knowledge, then use-case agents in row order).
 */
/**
 * "What should handle it?" shows where routing can be measured — where the
 * bot engine's traces can be read (`useTraceAvailable`: localhost for now).
 * Elsewhere stored expectedAgent values are kept, just not shown.
 */
export { useTraceAvailable as useExpectedAgentEnabled } from './use-engine-trace';

export const agentChoices = (agents: CanvasAgentNode[]): ExpectedAgent[] =>
  orderForOverview(agents).map((a) => ({ id: a.id, title: a.title }));

/** The choice for a select's value, or null for "not specified" / a stale id. */
export const findAgentChoice = (
  choices: ExpectedAgent[],
  id: string | null | undefined
): ExpectedAgent | null =>
  id ? (choices.find((c) => c.id === id) ?? null) : null;
